import React, { Component } from 'react';
import Layout from "../layout/Layout";
import Navbar from "../layout/Header/Navbar";
import HomeMainContent from "../components/Home/HomeMainContent";
import PaymentGatewayNewFaqOne from "../components/Home/PaymentGatewayNewFaqOne";
import Footer from "../components/Home/Footer";
import ContactUsContent from "../components/Home/ContactUsContent";
import PaymentGatewayDashboardOptions from "../components/Home/PaymentGatewayDashboardOptions";
import AiContentGeneratorIntegration from "../components/Home/AiContentGeneratorIntegration";
import WhyChooseUs from "../components/Home/WhyChooseUs";

class Home extends Component {
    render() {
        return (
            <Layout>
                <Navbar />
                <HomeMainContent />
                <PaymentGatewayNewFaqOne />
                {/*<AiContentGeneratorIntegration />*/}
                <WhyChooseUs />
                <PaymentGatewayDashboardOptions />
                <ContactUsContent />
                {/*<AiContentGeneratorTab />*/}
                {/*<AiContentGeneratorInfocard />*/}
                {/*<AiContentGeneratorWork />*/}
                {/*<AiContentGeneratorIntegration />*/}
                {/*<AiContentGeneratorFeedback />*/}
                {/*<AiContentGeneratorPricing />*/}
                {/*<AiContentGeneratorCta />*/}
                <Footer />
            </Layout>
        );
    }
}

export default Home;
